import { CateringAggregationArticleViewModel } from '@dinein-lib/restapi-plugin';
import { CardActionTypeEnum } from './card-action-type.enum';

export class ArticleCard {
  constructor(public item: CateringAggregationArticleViewModel, public actionType: CardActionTypeEnum, public actionValue?: number) {}
}
